{
  "release": "2026d",
  "zones": 444,
  "source": "https://github.com/evansiroky/timezone-boundary-builder"
}
